/*
  Sail Workshop — mobil koleksiyon araç çubuğu davranışı

  - Görünüm değiştirici (1/2/3 sütun) — tercih SAKLANMAZ, her sayfada 2'den başlar
  - "Filtrele" mevcut Dawn mobil çekmecesini açar
  - Koleksiyon gezinme listesi ve yardım kutusu çekmecenin içine taşınır
  - Aşağı inince sol kenarda küçük filtre sekmesi belirir
*/
if (!customElements.get('collection-toolbar')) {
  customElements.define(
    'collection-toolbar',
    class CollectionToolbar extends HTMLElement {
      connectedCallback() {
        this.grid = document.getElementById('product-grid');
        this.viewButtons = Array.from(this.querySelectorAll('[data-columns]'));
        this.tab = document.querySelector('[data-filter-tab]');

        this.setupViews();
        this.setupFilterOpen();
        this.setupSort();
        this.setupActiveCount();
        this.setupFloatingTab();
        this.moveSidebarIntoDrawer();
        window.addEventListener('resize', () => this.moveSidebarIntoDrawer());

        // Filtreleme/sonsuz kaydırma ızgarayı ve çekmece içeriğini yeniden
        // oluşturuyor. Her değişiklikten sonra sütun sınıfını ve taşınan
        // blokları tekrar uygula.
        this.watchForRerenders();
      }

      watchForRerenders() {
        const container = document.getElementById('ProductGridContainer');
        const facets = document.getElementById('main-collection-filters');
        if (!('MutationObserver' in window)) return;

        let queued = false;
        const rerun = () => {
          if (queued) return;
          queued = true;
          requestAnimationFrame(() => {
            queued = false;
            this.applyColumns(this.current);
            this.moveSidebarIntoDrawer();
            this.setupActiveCount();
          });
        };

        if (container) new MutationObserver(rerun).observe(container, { childList: true, subtree: true });
        if (facets) new MutationObserver(rerun).observe(facets, { childList: true, subtree: true });
      }

      /* ---------- Görünüm değiştirici ---------- */

      setupViews() {
        // Tercih bilinçli olarak KAYDEDİLMEZ. Her yeni sayfa açılışında
        // varsayılan (2 sütun) görünümle karşılanır. Seçim yalnızca o sayfa
        // açık kaldığı sürece geçerlidir; filtreleme ve "daha fazla göster"
        // seçimi sıfırlamaz, başka bir koleksiyona geçmek sıfırlar.
        const fallback = this.dataset.defaultColumns || '2';
        this.current = ['1', '2', '3'].indexOf(fallback) > -1 ? fallback : '2';
        this.applyColumns(this.current);

        this.viewButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.current = button.dataset.columns;
            this.applyColumns(this.current);
          });
        });
      }

      applyColumns(columns) {
        // Izgara sayfa yenilenmeden değişebildiği için her seferinde tazeliyoruz.
        this.grid = document.getElementById('product-grid');
        if (this.grid) {
          this.grid.classList.remove('sw-cols-1', 'sw-cols-2', 'sw-cols-3');
          this.grid.classList.add('sw-cols-' + columns);
        }
        this.viewButtons.forEach((button) => {
          const on = button.dataset.columns === columns;
          button.classList.toggle('is-active', on);
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      /* ---------- Filtre çekmecesini açma ---------- */

      get drawerSummary() {
        return document.querySelector('.mobile-facets__wrapper summary');
      }

      openFilters() {
        const summary = this.drawerSummary;
        if (!summary) return;

        // Çekmeceyi açan <summary> sayfanın en üstünde duruyor. Tarayıcı
        // odağı oraya taşıdığı için sayfa başa sıçrıyordu. Kaydırma konumunu
        // saklayıp geri koyuyoruz — ziyaretçi kaldığı yerden devam etsin.
        const y = window.scrollY || window.pageYOffset || 0;
        const restore = () => window.scrollTo(0, y);

        summary.click();

        requestAnimationFrame(restore);
        window.setTimeout(restore, 80);
        window.setTimeout(restore, 260);

        const details = summary.closest('details');
        if (details && !details.dataset.swScrollGuard) {
          details.dataset.swScrollGuard = '1';
          details.addEventListener('toggle', () => {
            if (!details.hasAttribute('open')) {
              window.setTimeout(() => window.scrollTo(0, this.lastScrollY || 0), 0);
            }
          });
        }
        this.lastScrollY = y;
      }

      setupFilterOpen() {
        const button = this.querySelector('[data-open-filters]');
        if (button) button.addEventListener('click', () => this.openFilters());
      }

      /* ---------- Sıralama ---------- */

      setupSort() {
        const select = this.querySelector('[data-sort-select]');
        if (!select) return;
        select.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }

      /* ---------- Aktif filtre sayısı rozeti ---------- */

      setupActiveCount() {
        const badge = this.querySelector('[data-active-count]');
        if (!badge) return;
        const update = () => {
          const params = new URL(window.location.href).searchParams;
          let count = 0;
          params.forEach((value, key) => {
            if (key.indexOf('filter.') === 0 && value !== '') count += 1;
          });
          badge.textContent = count > 0 ? String(count) : '';
          badge.hidden = count === 0;
        };
        update();
      }

      /* ---------- Kenardaki küçük filtre sekmesi ---------- */

      setupFloatingTab() {
        if (!this.tab) return;
        this.tab.addEventListener('click', () => this.openFilters());

        if (!('IntersectionObserver' in window)) return;
        new IntersectionObserver(
          (entries) => {
            // Çubuk ekrandan çıkınca sekme belirir.
            this.tab.classList.toggle('is-visible', !entries[0].isIntersecting);
          },
          { threshold: 0 }
        ).observe(this);
      }

      /* ---------- Koleksiyon listesi + yardım kutusunu çekmeceye taşı ---------- */

      /* ---------- Koleksiyon listesi + yardım kutusu ----------
         SADECE MOBİLDE çekmeceye taşınır. Masaüstünde sol kenar çubuğunda
         kalmalılar; taşıma ekran genişliğinden bağımsız çalıştığında
         masaüstünde de kayboluyorlardı. Ekran büyütülürse geri konur. */

      get isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      moveSidebarIntoDrawer() {
        if (this.isMobile) {
          this.moveIntoDrawer();
        } else {
          this.restoreToSidebar();
        }
      }

      moveIntoDrawer() {
        const target = document.getElementById('FacetsWrapperMobile');
        const aside = document.querySelector('.facets-wrapper');
        if (!target || !aside) return;

        const nav = aside.querySelector('.coll-nav') || document.querySelector('.coll-nav');
        if (nav && nav.parentElement !== target) {
          if (!nav.dataset.swHome) nav.dataset.swHome = '1';
          nav.classList.add('coll-nav--in-drawer');
          target.insertBefore(nav, target.firstChild);
        }

        const help = aside.querySelector('.facets-help') || document.querySelector('.facets-help');
        if (help && help.parentElement !== target) {
          if (!help.dataset.swHome) help.dataset.swHome = '1';
          help.classList.add('facets-help--in-drawer');
          target.appendChild(help);
        }
      }

      restoreToSidebar() {
        const aside = document.querySelector('.facets-wrapper');
        if (!aside) return;

        const nav = document.querySelector('.coll-nav--in-drawer');
        if (nav) {
          nav.classList.remove('coll-nav--in-drawer');
          aside.insertBefore(nav, aside.firstChild);
        }

        const help = document.querySelector('.facets-help--in-drawer');
        if (help) {
          help.classList.remove('facets-help--in-drawer');
          aside.appendChild(help);
        }
      }
    }
  );
}
